export default {
  REFRESH_SUCCESS: '刷新成功',
  REFRESH_FAILED_AND_TIP: '刷新失败:无当前地图校正参数'
}
